var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6 offset-lg-3 col-12 text-center p-0" },
          [
            _c("div", { staticClass: "card shadow-sm" }, [
              _c("div", { staticClass: "card-body" }, [
                _c("p", { staticClass: "h6" }, [
                  _vm._v(
                    "กรุณายืนยันตัวตนผู้กู้และผู้คำประกัน เพื่อทำการยื่นขอสินเชื่อเงินสดผ่าน App"
                  )
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "h5" }, [
                  _vm._v(
                    "กรุณาอัปโหลดรูปถ่ายที่เห็นทั้งบัตรประชาชนและใบหน้าอย่างชัดเจน"
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row no-gutters mt-3" }, [
                  _c("div", { staticClass: "col-12 text-left" }, [
                    _vm._v("1. โปรดถ่ายรูปบัตรประจำตัวประชาชนของคุณ")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("img", {
                      staticClass: "img-fluid pa-2",
                      attrs: {
                        src: "/static/img/nimcap/IdCard1.jpg",
                        alt: ".."
                      }
                    })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row no-gutters mt-3" }, [
                  _c("div", { staticClass: "col-12 text-left" }, [
                    _vm._v(
                      "\n                            2. โปรดถือบัตรประจำตัวประชาชนและถ่ายรูปคู่กับบัตรประชาชน\n                        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12" }, [
                    _c("img", {
                      staticClass: "img-fluid pa-2",
                      attrs: {
                        src: "/static/img/nimcap/IdCard2.png",
                        alt: ".."
                      }
                    })
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bcb4cd98", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bcb4cd98","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nimcap/Components/Borrower/Step3.vue
// module id = 2272
// module chunks = 0